import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetAddMultipleSpocsToProjectScheduleJobStatusRPC } from "./getAddMultipleSpocsToProjectScheduleJobStatusRPC";

export class GetAddMultipleSpocsToProjectScheduleJobStatusRPCClientImpl extends GetAddMultipleSpocsToProjectScheduleJobStatusRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Request): Promise<LeoRPCResult<GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Response, GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/GetAddMultipleSpocsToProjectScheduleJobStatus",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetAddMultipleSpocsToProjectScheduleJobStatusRPC.ResponseDTO,
      GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Errors.ErrorsDTO,
      GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Response,
      GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Errors.Errors
    >(
      response,
      "spoc-management/GetAddMultipleSpocsToProjectScheduleJobStatus",
      GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Response.fromDTO,
      GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Errors.fromDTO
    );
  }
}
